import { Component, ViewEncapsulation, Input } from '@angular/core';

@Component({
    selector: 'why-open-account-card',
    templateUrl: './why-open-account-card.component.html',
    styleUrls: ['./why-open-account-card.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [],
})
export class WhyOpenAccountCardComponent  {

    public tooltips: {[prop: string]: string} = {};

    public ngOnInit() {
        this.startTips();
    }

    public startTips() {

        this.tooltips.secure = `
            <div>              
                <div class='pop-content'>
                    Com a gente você encontra investimentos com a mesma garantia da Poupança e a
                    confiança de uma das maiores empresas de investimento do país, 100% autorizada pelo Banco Central do Brasil e pela CVM.
                </div>
            </div>
        `;
    }
}
